let operatorTxt = {
	selectCard: "10秒以内にカードを記憶してください。",
	gameDescription: "同じカードを選んでください。<br class='u-sp'>お手つきは5秒のペナルティです。",
	start: "GAME START!",
	modal: "正解したカードを選ぶとASL社員について<br class='u-sp'>知ることができます。",
	end: "FINISH!"
}
let $html = document.documentElement;
export let operator = {
	target: null,
	wrap: null,
	inner: null,
	init: function(){
		operator.target = document.querySelector(".b-operator p");
		operator.wrap = document.querySelector(".b-operator .c-text");
		operator.inner = document.querySelector(".b-operator .c-inner");
	},
	change: function( type, closeTime ){
		let txt = operatorTxt[type];
		operator.target.innerHTML = txt;
		if( type === "start" || type === "end" ){
			operator.target.classList.add("size-l");
		}else{
			operator.target.classList.remove("size-l");
		}
		setTimeout(function(){
			operator.show( closeTime );
		}, 50);
	},
	show: function( closeTime ){
		let w = operator.target.clientWidth;
		if( !$html.classList.contains("show-operator") ){
			$html.classList.add("show-operator");
			//console.log(operator.target, w);
			operator.wrap.style.width = w + "px";
			setTimeout(function(){
				operator.hide();
			}, closeTime);
		}
	},
	hide: function(){
		const root = getComputedStyle(document.querySelector(".b-operator"));
		const baseW = root.getPropertyValue('--operator-height');
		operator.wrap.style.width = baseW;
		if( $html.classList.contains("show-operator") ){
			$html.classList.remove("show-operator");
		}
	}
}